const search = {
  namespaced: true,

  state: {
    channel: '',
    // parkIds: '',
    showVoice: ''

  },

  mutations: {
    SET_CHANNEL: (state, msg) => {
      state.channel = msg
    },
    // SET_PARKIDS: (state, msg) => {
    //   state.parkIds = msg
    // },
    SET_SHOWVOICE: (state, msg) => {
      state.showVoice = msg
    }

  },

  actions: {
    channel({ commit }, msg) {
      commit('SET_CHANNEL', msg)
    },
    // parkIds({ commit }, msg) {
    //   commit('SET_PARKIDS', msg)
    // },
    showVoice({ commit }, msg) {
      commit('SET_SHOWVOICE', msg)
    }

  }
}

export default search



// WEBPACK FOOTER //
// ./src/store/modules/search.js